import axios from 'axios';

/**
 * Get CSRF token from meta tag
 */
const getCsrfToken = () => {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
};

/**
 * Get brand ID from gon
 */
const getBrandId = () => {
  return window.gon?.current_brand || '';
};

const SignInService = {
  /**
   * Sign in a user via Devise session
   * @param {string} email - User's email address
   * @param {string} password - User's password
   * @returns {Promise<Object>} - The response data from the server
   * Response includes: success, user_id, pro_user, user_role, user object, etc.
   * Session cookie is automatically set by the browser from server response headers.
   */
  
  signIn: async (email, password) => {
    const authenticity_token = getCsrfToken();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': authenticity_token,
        'X-Requested-With': 'XMLHttpRequest'
      },
      withCredentials: true
    };

    const userData = {
      login_id: email,
      password: password,
      frontend_app: true
    };

    const response = await axios.post(`/api/v5/sessions?brand_id=${getBrandId()}`, userData, config);
    return response.data;
  }
};

export default SignInService;
